<template>
  <div class="find-invoice-container">
    <AppHeader title="Find Invoice" />
    <qrcode-vue class="vue_qrcode_ref" style="display: none;" v-if="efrisData.ura_qr_code" level="H" size="300"
      :value="efrisData.ura_qr_code"></qrcode-vue>
    <vue-barcode class="vue_barcode_ref" style="display: none;" v-if="invoive_order_id != ''" :options="{ width: 3 }"
      :value="invoive_order_id"></vue-barcode>

    <div class="search-section" style="margin-top: 35px;">
      <div class="search-container">
        <input
        autocomplete="one-time-code"
          ref="invoive_order_id"
          v-model="invoive_order_id"
          @keydown.enter.prevent="handleEnter"
          type="text"
          class="search-input"
          placeholder="Enter Invoice Number or Scan QR..."
          id="invoive_order_id"
          name="invoive_order_id"

        />
        <button @click="getOrder(invoive_order_id)" class="search-btn">🔎 Search</button>
      </div>
    </div>

    <div v-if="showOrder" class="action-buttons">
      <button v-if="hasPermission(29)" @click="printUgandaOrder()" class="btn-action btn-print">🖨️ Print</button>
      <button v-if="hasPermission(28)" @click="handleReturn(invoive_order_id)" class="btn-action btn-return">↩️ Return</button>
      <button v-if="hasPermission(27)" @click="deleteOrder(invoive_order_id)" class="btn-action btn-void">❌ Void</button>
      <button v-if="hasPermission(30)" @click="isLoyalityOpen = true" class="btn-action btn-customer">👤 Pick Customer</button>
    </div>

    <div class="main-content">
      <div v-if="showOrder" class="invoice-header-section">
        <div class="invoice-card">
          <div class="invoice-item">
            <span class="label">Invoice Number:</span>
            <span class="value">{{ orders[0]?.orderId }}</span>
          </div>
          <div class="invoice-item">
            <span class="label">Items Count:</span>
            <span class="value">{{ orders[0]?.ItemsCount }}</span>
          </div>
          <div class="invoice-item">
            <span class="label">Total:</span>
            <span class="value">{{ orders[0]?.totalPrice }}</span>
          </div>
          <div class="invoice-item">
            <span class="label">User:</span>
            <span class="value">{{ orders[0]?.userName }}</span>
          </div>
          <div class="invoice-item">
            <span class="label">Date:</span>
            <span class="value">{{ orders[0]?.orderDate }}</span>
          </div>
          <div class="invoice-item">
            <span class="label">Customer:</span>
            <span class="value">{{ customer_name || 'Walk In' }}</span>
          </div>
        </div>
      </div>
      <div v-if="showOrderDetails" class="items-section">
        <div class="section-header">
          <h2 class="section-title">📦 Items</h2>
          <span class="item-count">{{ orderDetails.length }} items</span>
        </div>
        <div class="items-table-wrapper">
          <table class="items-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th class="right">Qty</th>
                <th class="right">Unit Price</th>
                <th class="right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in orderDetails" :key="item.item_code" class="item-row">
                <td class="item-name">{{ item.item_name }}</td>
                <td class="right">{{ parseFloat(item.qty).toFixed(3) }}</td>
                <td class="right">{{ formatNumber(item.standard_rate) }}</td>
                <td class="right total-cell">{{ formatNumber(item.price) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="showOrder" class="summary-section">
        <div class="summary-grid">
          <div class="summary-card">
            <div class="summary-header">💵 Summary</div>
            <div class="summary-rows">
              <div class="summary-row">
                <span class="summary-label">Items:</span>
                <span class="summary-value">{{ orderDetails.length }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Net Total:</span>
                <span class="summary-value">{{ formatNumber(netTotalAmount) }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">VAT:</span>
                <span class="summary-value">{{ formatNumber(vatAmount) }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Discount:</span>
                <span class="summary-value discount">-{{ formatNumber(discountAmount) }}</span>
              </div>
              <div class="summary-row total-row">
                <span class="summary-label">Grand Total:</span>
                <span class="summary-value grand">{{ formatNumber(grandTotalAmount) }}</span>
              </div>
            </div>
          </div>

          <div class="payment-card">
            <div class="card-header">💳 Payment Methods</div>
            <div class="payment-rows">
              <div class="payment-row">
                <span class="payment-label">Gift Card:</span>
                <span class="payment-value">{{ (parseFloat(this.balance)).toFixed(2) }}</span>
              </div>
              <div class="payment-row">
                <span class="payment-label">Cash:</span>
                <span class="payment-value">{{ (parseFloat(this.orderCashAmount)).toFixed(2) }}</span>
              </div>
              <div class="payment-row">
                <span class="payment-label">Mobile:</span>
                <span class="payment-value">{{ (parseFloat(this.orderMobileAmount)).toFixed(2) }}</span>
              </div>
              <div class="payment-row">
                <span class="payment-label">Credit:</span>
                <span class="payment-value">{{ (parseFloat(this.orderCreditAmount)).toFixed(2) }}</span>
              </div>
              <div class="payment-row">
                <span class="payment-label">Account:</span>
                <span class="payment-value">{{ (parseFloat(this.orderAccountAmount)).toFixed(2) }}</span>
              </div>
            </div>
          </div>

          <div v-show="showloyality" class="loyalty-card">
            <div class="card-header">👤 Customer Info</div>
            <div class="loyalty-details">
              <div class="loyalty-row">
                <span class="label">Name:</span>
                <span class="value">{{ this.name }}</span>
              </div>
              <div class="loyalty-row">
                <span class="label">Gender:</span>
                <span class="value">{{ this.gender }}</span>
              </div>
              <div class="loyalty-row">
                <span class="label">Email:</span>
                <span class="value">{{ this.email }}</span>
              </div>
              <div class="loyalty-row">
                <span class="label">Phone:</span>
                <span class="value">{{ this.phone }}</span>
              </div>
              <div class="loyalty-row">
                <span class="label">Points:</span>
                <span class="value">{{ this.totalpoints }}</span>
              </div>
              <div class="loyalty-row">
                <span class="label">Member Since:</span>
                <span class="value">{{ this.customersince }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loiality :open="isLoyalityOpen" :loyality="this.loyality" @getLoialityPoints="setLoialityPoints($event)"
      @close="isLoyalityOpen = !isLoyalityOpen" />
    <Void :open="isVoidOpen" @getVoidUserId="setVoidUserId($event)" @getVoidPermission="setVoidPermission($event)"
      @close="isVoidOpen = !isVoidOpen" />

  </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode';
import QrcodeVue from 'qrcode.vue'
import axios from "axios";
import router from '@/router';
import Loiality from "@/components/Loiality";
import Void from "@/components/Void";
import commonServices from "@/shared/commonServices"
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";

const Swal = require('sweetalert2');

export default {
  name:"FindInvoice",
  mixins: [commonServices],
  mounted() {
    this.language = 'ar';
    this.handleLanguage();
    this.getHeaderFooter();
    this.getTaxAmount();

  },
  components: { Loiality, Void, MainMenu, VueBarcode, QrcodeVue, AppHeader },
  data: function () {
    return {
      taxBaseAmount: 1.18,
      balance: 0,
      cashAmount: 0,
      creditAmount: 0,
      efrisData: {
        ura_invoice_id: "fiwkfiwjefijwiejf",
        ura_invoice_no: "wokefkewofkwoekfowkefokweok",
        ura_verification_code: "f93092kweoofwkefwefw9ef",
        ura_qr_code: "wofekw9ef9wefkwofew9ef9ei",
      },
      accountAmount: 0,
      customernumber: '',
      orderCashAmount: 0,
      orderCreditAmount: 0,
      orderMobileAmount: 0,
      orderAccountAmount: 0,
      payments: [],
      orderItems: [],
      gender: "",
      customersince: '',
      languageName: '',
      customer_tin: '',
      voidUserId: 0,
      authorizedToChangePrice: '',
      isVoidOpen: false,
      showError: false,
      showloyality: false,
      jsonData: {},
      orders: [],
      orderHeader: {},
      orderDetails: [],
      invoive_order_id: "",
      isLoyalityOpen: false,
      loyality: null,
      showOrder: false,
      showOrderDetails: false,
      paymentMethod: {},
      invoiceHeader: '',
      invoiceFooter: '',
      totalOrderAmount: 0,
      grandTotalAmount: 0,
      netTotalAmount: 0,
      diffAmount: 0,
      vatAmount: 0,
      notPaidAmount: 0,
      totalpoints: 0,

      outstandingAmount: '',
      discountAmount: 0,
      return_ok: false,
      reports_ok: false,

      customer_name: "",
      name: "",
      phone: "",
      email: "",
      line1: "",
      line2: "",
      area: "",
      city: "",
    }
  },
  created() {
    this.invoive_order_id = this.$route.params.invoiceNumber;
    this.getOrder(this.invoive_order_id);
  },
  methods: {
    setLoialityPoints(loyality) {
      //this.loyality=loyality;
      //console.log("loyality", loyality)
      //this.customer_name = this.loyality.results[0].name;
      //localStorage.name = this.loyality.results[0].name;
      if (loyality.results[0].id != 0 && loyality.results[0].id !== null) {
        localStorage.customerId = loyality.results[0].id;
        this.getCustomerById(loyality.results[0].id);
        this.showloyality = true;
      }
      //console.log("localStorage.customerId", localStorage.customerId)
      //localStorage.loyality = this.loyality.results[0];

    },
    clearCustomerInfos(loyality) {
      this.customer_name = "";
      this.name = "";
      this.email = "";
      this.phone = "";
      this.customerId = "";
      this.totalpoints = "";

      this.loyality = null;
      this.customer_name = "";
      //localStorage.name = "";
      localStorage.removeItem("name");
      //localStorage.customernumber = this.loyality.results[0].customernumber;
      //localStorage.loyality = this.loyality.results[0];

    },

    getCustomerById: async function (customerId) {
      try {

        let dataURL = this.apiURL + 'Loyalty/getCustomerById';
        let loialityJson = { "appId": localStorage.appId, 'customerId': customerId };
        let response = await axios.post(dataURL, loialityJson);
        this.loiality = response.data.results[0];
        this.customer_name = response.data.results[0].name;
        this.name = response.data.results[0].name;
        this.email = response.data.results[0].email;
        this.phone = response.data.results[0].phone;
        this.customerId = response.data.results[0].id;

        this.line1 = response.data.results[0].line1;
        this.line2 = response.data.results[0].line2;
        this.area = response.data.results[0].area;
        this.city = response.data.results[0].city;
        this.totalpoints = response.data.results[0].totalpoints;


      }
      catch (error) {
        console.log(error);
      }
    },

    handleReturn: function (orderId) {
      if (this.name !== "") {
        localStorage.return_order = orderId;
        this.$router.push({ name: 'returns' });
      } else {
        this.showAlert("Please pick a customer");
      }
    },

    deleteOrder(id) {
      this.isVoidOpen = true;
    },

    setVoidUserId(userId) {
      this.voidUserId = parseInt(userId);
    },

    setVoidPermission(authorizedToChangePrice) {
      if (this.orders[0].isDeleted === '1') {
        this.showAlert(" This invoice alredy voided");
      } else {
        this.authorizedToChangePrice = authorizedToChangePrice;
        if (this.authorizedToChangePrice === 'Y') {

          this.voidOrder(this.invoive_order_id);
          this.showSuccess("Done!");
        } else {
          // Error message mo permission
          this.showAlert("You do ot have permission for this action!");
        }
        this.authorizedToChangePrice = 'N'

      }
    },
    handleEnter() {
      if (this.invoive_order_id) {
        this.getOrder(this.invoive_order_id);
      }
    },

    getOrder: async function (id) {
      try {
        this.customer_name = "";
        this.customer_tin = "";
        this.loyality = {};

        this.showError = false;
        this.orders = [];
        this.orderDetails = [];
        let dataURL = this.apiURL + 'Orders/getOrder';

        let orderJson = { "appId": localStorage.appId, 'orderId': id };
        let response = await axios.post(dataURL, orderJson);
        if (response.data.status === 'success') {
          if (response.data.results.payments) {
            this.payments = response.data.results.payments;
            if (this.payments.length > 0) {
              for (var i = 0; i < this.payments.length; i++) {
                if (this.payments[i].paymentType == "cash") {
                  this.orderCashAmount = this.payments[i].amount;
                }
                if (this.payments[i].paymentType == "credit") {
                  this.orderCreditAmount = this.payments[i].amount;
                }
                if (this.payments[i].paymentType == "account") {
                  this.orderAccountAmount = this.payments[i].amount;
                  this.customerId = this.payments[i].accountId;
                }
                if (this.payments[i].paymentType == "mobile") {
                  this.orderMobileAmount = this.payments[i].amount;
                }
              }

            }
          }

          let parkStatus = response.data.results.parkStatus;
          if (parkStatus === "1" || parkStatus === "2" || parkStatus === "3") {
            this.showAlert("You can not return unpaid invoices");
          } else {
            if (localStorage.return_ok === "1") {
              this.return_ok = true
            }
            let orderHeader = {};
            orderHeader.orderId = response.data.results.invoice;
            this.customer_tin = response.data.results.customer_tin;
            orderHeader.ItemsCount = response.data.results.ItemsCount;
            this.efrisData = {

              ura_invoice_id: response.data.results.ura_invoice_id,

              ura_invoice_no: response.data.results.ura_invoice_no,

              ura_verification_code: response.data.results.ura_verification_code,

              ura_qr_code: response.data.results.ura_qr_code

            }
            orderHeader.totalPrice = response.data.results.totalPrice;
            orderHeader.userId = response.data.results.userId;
            orderHeader.userName = response.data.results.userName;
            orderHeader.customerId = response.data.results.customerId;
            this.discountAmount = Math.round(100 * parseFloat(response.data.results.disValue).toFixed(2)) / 100;
            orderHeader.orderDate = response.data.results.orderDate;
            orderHeader.isDeleted = response.data.results.isDeleted;
            orderHeader.deleted_on = response.data.results.deleted_on;

            if (orderHeader.isDeleted === "1") {
              this.showAlert("Invoice is voided on " + orderHeader.deleted_on);
              this.showloyality = false;
              this.showOrder = false;
              this.showOrderDetails = false;
              this.clearCustomerInfos();
              this.orders = [];
              this.orderDetails = [];
            } else {
              if (orderHeader.totalPrice < 0) {
                this.showAlert("Return invoice can not be modified!");
                this.showloyality = false;
                this.showOrder = false;
                this.showOrderDetails = false;
                this.clearCustomerInfos();
                this.orders = [];
                this.orderDetails = [];
              } else {
                this.orders.push(orderHeader);
                this.showOrder = true;
                this.calcOrderTotalAmount();
                this.orderDetails = response.data.results.items;
                this.orderItems = this.orderDetails;
                this.calcOrderTotalAmount();
                this.showOrderDetails = true;
                if (orderHeader.customerId !== "" && orderHeader.customerId !== "0") {
                  this.getCustomerById(orderHeader.customerId)
                  this.showloyality = true;
                } else {
                  this.showloyality = false;
                  this.clearCustomerInfos();
                }
              }
            }
          }
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    printUgandaOrder() {
      this.isPrinted = false;
      let barcodeCanvas = document.querySelector('.vue_barcode_ref');
      let barcodeImageSrc = barcodeCanvas.toDataURL();
      let qrcodeImageSrc = '';
      if (this.efrisData.ura_qr_code) {
        let qrcodeCanvas = document.querySelector('.vue_qrcode_ref');
        qrcodeImageSrc = qrcodeCanvas.toDataURL();
      }
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.toLocaleString('en-us', { month: 'short' });
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let rows = ``
      let self = this;
      let formatNumber = this.formatNumber;
      let quantity = 0
      this.orderItems.forEach(function (order) {
        quantity += order.qty
        rows += `<tr>
              <td colspan="5">${order.item_name}</td>
            </tr>
            <tr>
              <td style="text-align:center"></td>
              <td style="text-align:center">${parseFloat(order.qty).toFixed(3)}</td>
              <td style="text-align:center">${order.uom ?? 'PCS'}</td>
              <td style="text-align:center">${formatNumber(order.standard_rate)}</td>
              <td style="text-align:center">${formatNumber(order.price)}</td>
            </tr>`
      });
      let payments = ``;
      let payTotal = 0
      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {
        payTotal += this.discountAmount;
        payments += `<tr>
              <td colspan="4">Discount</td>
              <td style="text-align:center">${(this.formatNumber(this.discountAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.orderCashAmount) * 100) / 100 > 0) {
        payTotal += this.orderCashAmount;
        payments += `<tr>
              <td colspan="4">Cash</td>
              <td style="text-align:center">${(this.formatNumber(this.orderCashAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.orderCreditAmount) * 100) / 100 > 0) {
        payTotal += this.orderCreditAmount;
        payments += `<tr>
              <td colspan="4">Credit</td>
              <td style="text-align:center">${(this.formatNumber(this.orderCreditAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.orderMobileAmount) * 100) / 100 > 0) {
        payTotal += this.orderMobileAmount;
        payments += `<tr>
              <td colspan="4">Mobile</td>
              <td style="text-align:center">${(this.formatNumber(this.orderMobileAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.orderAccountAmount) * 100) / 100 > 0) {
        payTotal += this.orderAccountAmount;
        payments += `<tr>
              <td colspan="4">Account</td>
              <td style="text-align:center">${(this.formatNumber(this.orderAccountAmount))}</td>
            </tr>`
      }
      if (this.balance > 0) {
        payments += `<tr>
              <td colspan="4">Balance</td>
              <td style="text-align:center">${(this.formatNumber(this.balance))}</td>
            </tr>`
      }
      else {
        if (this.balance !== 0) {
          `<tr>
              <td colspan="4">Balance</td>
              <td style="text-align:center">${(this.formatNumber(this.balance))}</td>
            </tr>`
        }
      }
      let changeTotal = payTotal - this.grandTotalAmount;
      if (changeTotal > 0) {
        changeTotal = `<tr>
              <td colspan="4">Change</td>
              <td style="text-align:center">${(this.formatNumber(changeTotal))}</td>
            </tr>`
      } else {
        changeTotal = ``
      }
      let customerPoints = '';
      if (this.loyality != null) {
        customerPoints += `
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Points From This Sale:</p>
         <p> ${this.earnedpoints} </p>
        </div>
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Total Points:</p>
         <p> ${this.totalpoints + this.earnedpoints} </p>
        </div>
        
        `
      }
      let efrisPart = '';
      // if (this.posData.efris_on != '0') {
        if (this.efrisData.ura_qr_code) {
          efrisPart = `
            <p>Fiscal Doc No:      ${this.efrisData.ura_invoice_no}  </p>
            <p>Verification Code:      ${this.efrisData.ura_verification_code}  </p>
            <img style="margin-bottom:4rem" width="60" src="${qrcodeImageSrc}"/>
          `;
        } else {
          efrisPart = '<p>Failed To Sync To URA</p>'
        }
      // }
      let elem = `
      <h6 style="text-align: right">Reprint</h6>
    ${this.invoiceHeader}
    <div style="display: flex; justify-content: center;flex-direction:column">
      
      
        <table>
          <thead>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
              col="2"
            >
              Item
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Qty
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Unit
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Price
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Amount
            </th>
          </thead>
          <tbody>
            ${rows}
            <tr style="height: 15px;">
              <td colspan="5"></td>
            </tr>
            <tr>
              <td colspan="6" style="border-bottom: 1px dashed;text-align:center;font-weight: bolder;font-size: 1rem !important;padding-bottom: .8rem;">${this.orderItems.length} Items Sold</td>
            </tr>
            <tr style="font-weight: 1000;">
              <td style="font-size: 1.1.rem !important;" colspan="4">Total</td>
              <td style="font-size: 1.1.rem !important;text-align:center">${this.formatNumber(this.grandTotalAmount)}</td>
            </tr>
            ${payments}
            <tr>
                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>
            </tr>
            <tr>
              <td style="padding-top:.5rem;" colspan="4">Tendered Total</td>
              <td style="padding-top:.5rem;text-align:center">${this.formatNumber(this.paidAmount)}</td>
            </tr>
            ${changeTotal}
            <tr>
              <td colspan="2" style="padding-top:.5rem;">VAT</td>
              <td style="padding-top:.5rem;">Amt W/o VAT</td>
              <td style="padding-top:.5rem;">VAT Amt</td>
              <td style="padding-top:.5rem;">Net Amt</td>
            </tr>
            <tr>
              <td colspan="2" style="padding-top:.5rem;">Standard</td>
              <td style="padding-top:.5rem;">${this.formatNumber(this.netTotalAmount)}</td>
              <td style="padding-top:.5rem;">${this.formatNumber(this.vatAmount)}</td>
              <td style="padding-top:.5rem;">${this.formatNumber(this.grandTotalAmount)}</td>
            </tr>
            <tr>
                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>
            </tr>
           
          </tbody>
        </table>
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Customer Name:</p>
         <p> ${this.loyality != null || this.phone !== "" ? this.name : 'Cash Customer'} </p>
        </div>

        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Customer TIN Number:</p>
         <p> ${this.loyality != null || this.phone !== "" ? this.customer_tin : '-'} </p>
        </div>
        
        ${customerPoints}
        <div style="display: flex; justify-content: center">
          <img style="width:65%"
            src="${barcodeImageSrc}"
          />
        </div>

        <table style="margin-bottom: 1rem;">
            <thead>
              <th
                style="padding: .5rem 0;"
                col="2"
              >
                Date
              </th>
              <th
                style="padding: .5rem 0;"
              >
                Time
              </th>
              <th
                style="padding: .5rem 0;"
              >
                Served By
              </th>
              
            </thead>
            <tbody>
              <tr>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${day} ${month} ${year}</td>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${time}</td>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${localStorage.username}</td>
              </tr>

            
            </tbody>
          </table>
          ${efrisPart}
          ${this.invoiceFooter}
      `

      var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');

      //mywindow.document.write('<img src="'+this.logoUrl+'" alt="Logo" width="100%"></img>');
      //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+'<img src='+this.logoUrl+' width="100%" alt="Logo">'+'</td></tr></table>'; 

      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      //newEle = newEle + this.invoiceHeader+elem+this.invoiceFooter;
      //newEle = newEle + elem;
      mywindow.document.write(elem);


      //mywindow.document.close(); // necessary for IE >= 10
      //mywindow.focus(); // necessary for IE >= 10*/
      //const myTimeout = setTimeout("", 1000); 
      setTimeout(function () { mywindow.print(); mywindow.close(); }, 300);
      this.isPrinted = true;
      return true;
    },


    getHeaderFooter: async function () {
      try {
        let dataURL = this.apiURL + 'Orders/getInvoiceHeader';
        let logoJson = { "branchId": "1", "langId": "15" };
        let response = await axios.post(dataURL, logoJson);
        if (response.data.status === 'success') {
          this.invoiceHeader = response.data.results.header;
          this.invoiceFooter = response.data.results.footer;
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    calcOrderTotalAmount: function () {

      this.vatAmount = this.calcOrderVatTotal();
      this.netTotalAmount = this.calcOrderNetTotal();
      this.grandTotalAmount = this.netTotalAmount + this.vatAmount - this.discountAmount;
    },
    getTaxAmount: async function () {
      try {

        let dataURL = this.apiURL + 'Products/getTaxAmount';
        let response = await axios.post(dataURL, {});
        if (response.data.status === 'success') {
          this.taxBaseAmount = response.data.tax;
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    calcOrderNetTotal: function () {
      let orderAmount = 0;
      if (this.orderDetails.length > 0) {
        let tax = this.taxBaseAmount;
        this.orderDetails.forEach(function (order) {
          if (order.tax == 'Standard') {
            let price = (order.standard_rate / tax) * order.qty;
            orderAmount = orderAmount + Math.round(price);
          } else {
            orderAmount = orderAmount + Math.round(order.price);
          }

        });
      }
      return orderAmount;
    },

    calcPrecision: function (amount) {
      let prcision = 0;
      let amountDiff = 0;
      let diff = parseFloat(amount).toFixed(2) - Math.round((parseFloat(amount).toFixed(2)));
      diff = Math.round(diff * 100) / 100;
      if (diff < 0) {
        diff = 1 + diff;
      }
      if (diff > 0) {
        if (diff >= 0 && diff <= 0.12) {
          prcision = 0
          amountDiff = 0 - diff;
        }
        if (diff > 0.12 && diff <= 0.37) {
          prcision = 0.25
          amountDiff = 0.25 - diff;
        }
        if (diff > 0.37 && diff <= 0.62) {
          prcision = 0.50;
          amountDiff = 0.5 - diff;
        }

        if (diff > 0.62 && diff <= 0.87) {
          prcision = 0.75;
          amountDiff = 0.75 - diff;
        }
        if (diff > 0.87 && diff <= 1) {
          prcision = 1;
          amountDiff = 1 - diff;
        }
        amountDiff = Math.round(amountDiff * 1000) / 1000;
      }
      prcision = parseFloat(((Math.round(prcision * 1000)) / 1000)).toFixed(2);
      return amountDiff;
    },

    calcAmountPrecision: function (amount) {
      this.calcPrecision(amount)
      return amount + this.calcPrecision(amount);
    },
    calcOrderVatTotal: function () {
      let orderVatAmount = 0;
      let tax = this.taxBaseAmount;
      if (this.orderDetails.length > 0) {

        this.orderDetails.forEach(function (order) {

          if (order.tax == 'Standard') {
            let newStandardRate = order.standard_rate / tax;
            let newPrice = newStandardRate * order.qty;
            let vatAmount = order.price - newPrice;
            orderVatAmount += Math.round(vatAmount)
          }
        });
      }
      return orderVatAmount;
    },

    // calcOrderDiscount: function () {
    //   let dis = 0;
    //   if (this.discountAmount !== 0) {
    //     dis = this.discountAmount;
    //   } else {
    //     let promoDis = 0;
    //     if (this.prompMinimum_total <= this.netTotalAmount) {
    //       if (this.orderDetails.length > 0) {
    //         this.orderDetails.forEach(function (order) {
    //           if (order.item_discount != null && order.item_discount !== undefined) {
    //             promoDis = promoDis + parseFloat(order.item_discount) * order.price / 100;
    //           }
    //         });
    //       }

    //     }
    //     dis = promoDis;
    //     let persDis = 0;
    //     if (this.dis_percentage > 0) {
    //       persDis = this.netTotalAmount * (this.dis_percentage / 100);
    //     }

    //     if (persDis > promoDis) {
    //       dis = persDis;
    //     }

    //   }
    //   return dis;
    // },

  }
}
</script>

<style scoped>

.find-invoice-container {
  height: 100vh;
  overflow-y: auto;
  background: linear-gradient(135deg, var(--bg-dark) 0%, var(--bg-dark-secondary) 100%);
  margin-top: -20px;
}

.page-header {
  background: linear-gradient(135deg, #5c6bc0 0%, #3f51b5 100%);
  box-shadow: 0 4px 20px rgba(92, 107, 192, 0.3);
  padding: 2rem;
  position: sticky;
  top: 0;
  z-index: 50;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
}

.page-title {
  margin: 0;
  color: white;
  font-size: 2rem;
  font-weight: 800;
}

.page-subtitle {
  margin: 0.5rem 0 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 1rem;
}

.search-section {
  max-width: 1400px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.search-container {
  display: flex;
  gap: 1rem;
  align-items: center;
  animation: slideDown 0.5s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-input {
  flex: 1;
  background: linear-gradient(135deg, #1e2332 0%, #252d42 100%);
  border: 2px solid rgba(92, 107, 192, 0.3);
  color: white;
  padding: 1rem 1.25rem;
  border-radius: 14px;
  font-size: 1.4rem;
  transition: all 0.3s ease;
  min-height: 55px;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.search-input:focus {
  outline: none;
  border-color: #5c6bc0;
  background: rgba(92, 107, 192, 0.15);
  box-shadow: 0 0 0 4px rgba(92, 107, 192, 0.1);
}

.search-btn {
  background: linear-gradient(135deg, #5c6bc0 0%, #3f51b5 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 14px;
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 55px;
  white-space: nowrap;
  box-shadow: 0 4px 15px rgba(92, 107, 192, 0.3);
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(92, 107, 192, 0.4);
}

.action-buttons {
  max-width: 1400px;
  margin: 1.5rem auto;
  padding: 0 1rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.btn-action {
  flex: 2;
  min-width: 40px;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-size: 1.7rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
}

.btn-print {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.btn-print:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.btn-return {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
}

.btn-return:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
}

.btn-void {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);
}

.btn-void:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4);
}

.btn-customer {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
}

.btn-customer:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 152, 0, 0.4);
}

.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem 2rem;
}

.invoice-header-section {
  margin-bottom: 2rem;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.invoice-card {
  background: linear-gradient(135deg, #1e2332 0%, #252d42 100%);
  border: 1px solid rgba(92, 107, 192, 0.2);
  border-radius: 16px;
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.invoice-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(92, 107, 192, 0.1);
  border-radius: 12px;
  border-left: 4px solid #5c6bc0;
}

.invoice-item .label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.4rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.invoice-item .value {
  color: white;
  font-size: 1.25rem;
  font-weight: 700;
}

.items-section {
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #1e2332 0%, #252d42 100%);
  border: 1px solid rgba(92, 107, 192, 0.2);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(92, 107, 192, 0.3);
}

.section-title {
  margin: 0;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
}

.item-count {
  background: rgba(92, 107, 192, 0.2);
  color: #7986cb;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.5rem !important;
}

.items-table-wrapper {
  overflow-x: auto;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
}

.items-table thead {
  background: rgba(92, 107, 192, 0.15);
  border-bottom: 2px solid rgba(92, 107, 192, 0.3);
}

.items-table th {
  padding: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 700;
  text-align: left;
  font-size: 1.5rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.items-table th.right {
  text-align: right;
}

.items-table tbody tr {
  border-bottom: 1px solid rgba(92, 107, 192, 0.15);
  transition: all 0.3s ease;
}

.items-table tbody tr:hover {
  background: rgba(92, 107, 192, 0.1);
}

.items-table td {
  padding: 1.25rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.5rem;
}

.items-table td.right {
  text-align: right;
}

.items-table td.total-cell {
  font-weight: 700;
  color: #7986cb;
}

.summary-section {
  width: 100%;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.summary-card,
.payment-card,
.loyalty-card {
  background: linear-gradient(135deg, #1e2332 0%, #252d42 100%);
  border: 1px solid rgba(92, 107, 192, 0.2);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.summary-card:hover,
.payment-card:hover,
.loyalty-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(92, 107, 192, 0.25);
}

.summary-header,
.card-header {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(92, 107, 192, 0.3);
}

.summary-rows {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: rgba(92, 107, 192, 0.08);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.summary-row:hover {
  background: rgba(92, 107, 192, 0.15);
}

.summary-label {
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
  font-size: 1.5rem;
}

.summary-value {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
  font-size: 1.5rem;
}

.summary-value.discount {
  color: #ff9800;
}

.summary-row.total-row {
  background: rgba(92, 107, 192, 0.25);
  border: 2px solid #5c6bc0;
  padding: 1rem;
  margin-top: 0.5rem;
}

.summary-value.grand {
  color: #7986cb;
  font-size: 1.55rem;
}

.payment-rows {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: rgba(92, 107, 192, 0.08);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.payment-row:hover {
  background: rgba(92, 107, 192, 0.15);
}

.payment-label {
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
}

.payment-value {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
}

.loyalty-details {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.loyalty-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: rgba(92, 107, 192, 0.08);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.loyalty-row:hover {
  background: rgba(92, 107, 192, 0.15);
}

.loyalty-row .label {
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
}

.loyalty-row .value {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
}

@media (max-width: 1200px) {
  .search-container {
    flex-wrap: wrap;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
  }

  .invoice-card {
    grid-template-columns: repeat(2, 1fr);
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 0.875rem;
  }

  .search-section {
    margin: 1rem auto;
  }

  .search-container {
    flex-direction: column;
  }

  .search-input,
  .search-btn {
    width: 100%;
  }

  .action-buttons {
    margin: 1rem auto;
  }

  .btn-action {
    flex: 1;
    min-width: 100px;
    padding: 0.75rem 1rem;
    font-size: 1.5rem;
  }

  .invoice-card {
    grid-template-columns: 1fr;
  }

  .invoice-item {
    padding: 0.875rem;
  }

  .items-section {
    padding: 1rem;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .items-table th,
  .items-table td {
    padding: 0.875rem;
    font-size: 1.2rem !important;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .item-count {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }

  .summary-card,
  .payment-card,
  .loyalty-card {
    padding: 1.25rem;
  }
}

@media (max-width: 480px) {
  .page-header {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .page-subtitle {
    display: none;
  }

  .main-content {
    padding: 0 0.5rem 1.5rem;
  }

  .search-section {
    margin: 1rem 0.5rem;
    padding: 0;
  }

  .search-input {
    padding: 0.875rem 1rem;
    font-size: 1rem;
  }

  .search-btn {
    padding: 0.875rem 1rem;
    font-size: 1rem;
  }

  .action-buttons {
    margin: 1rem 0.5rem;
    gap: 0.5rem;
  }

  .btn-action {
    padding: 0.75rem 0.875rem;
    font-size: 1.2rem;
    min-width: auto;
  }

  .invoice-card {
    gap: 0.5rem;
    padding: 1rem;
  }

  .invoice-item {
    padding: 0.75rem;
  }

  .items-section {
    padding: 0.75rem;
  }

  .items-table th,
  .items-table td {
    padding: 0.75rem 0.5rem;
    font-size: 1rem !important;
  }

  .summary-card,
  .payment-card,
  .loyalty-card {
    padding: 1rem;
  }

  .section-title {
    font-size: 1.1rem;
  }

  .summary-header,
  .card-header {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }

  .summary-row {
    padding: 0.5rem;
  }

  .payment-row {
    padding: 0.5rem;
  }

  .loyalty-row {
    padding: 0.5rem;
  }
}
</style>
